import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-60274a2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accordion-filter" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "no-results"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "category-title" }
const _hoisted_7 = {
  key: 0,
  class: "accordion-content"
}
const _hoisted_8 = {
  key: 0,
  class: "question-list"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-results" }, " No se encontraron preguntas con la palabra ingresada en la búsqueda ", -1))
const _hoisted_11 = { class: "faqs-question-modal" }
const _hoisted_12 = { class: "faqs-answer-modal" }
const _hoisted_13 = { class: "row tac" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['accordion', _ctx.props.accordion])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _hoisted_3,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.parametroBusqueda) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterAccordion && _ctx.filterAccordion(...args)))
          }, null, 544), [
            [_vModelText, _ctx.parametroBusqueda]
          ])
        ])
      ]),
      _createVNode(_component_center, null, {
        default: _withCtx(() => [
          (_ctx.noHayResultados)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No se encontraron resultados con la palabra ingresada en la búsqueda "))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultadosBusqueda, (categoria) => {
        return (_openBlock(), _createElementBlock("div", {
          key: categoria.categoriaId,
          class: "accordion-item"
        }, [
          _createElementVNode("div", {
            class: "accordion-header",
            onClick: ($event: any) => (_ctx.toggleCategoria(categoria))
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(categoria.nombreCategoria), 1),
            _createElementVNode("span", {
              class: _normalizeClass({ expanded: categoria.desplegado })
            }, "▼", 2)
          ], 8, _hoisted_5),
          (categoria.desplegado)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.hayPreguntas(categoria))
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.preguntasPorCategoria, (pregunta) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: pregunta.preguntaId,
                          class: "question-item",
                          onClick: ($event: any) => (_ctx.mostrarRespuesta(pregunta.pregunta, pregunta.respuesta))
                        }, _toDisplayString(pregunta.pregunta), 9, _hoisted_9))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_center, { key: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.mostrarPregunta,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mostrarPregunta) = $event)),
        "show-close": false
      }, {
        title: _withCtx(() => [
          _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.pregunta), 1)
        ]),
        default: _withCtx((content) => [
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.respuesta), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => [
              _createElementVNode("input", {
                class: "Button_BColorDegraded Button_fontButtonError",
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mostrarPregunta = false)),
                value: "Volver"
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ], 2),
    _createElementVNode("div", _hoisted_13, [
      (_ctx.props.showStartButton)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.GoToTransmission())),
            value: "Volver al inicio",
            class: "Button_BColorDegraded Button_fontButtonError"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}